import { ANALYTICS_API } from '@/services/constants';
import axiosClient from '../axiosClient';

const AnalyticServices = {
  fetchBasicStats: async (params: any) => {
    const response = await axiosClient.get(`${ANALYTICS_API}/basic`, {
      params
    });

    return response.data;
  },
  fetchApplicationStats: async (params: any) => {
    const response = await axiosClient.get(`${ANALYTICS_API}/application`, {
      params
    });

    return response.data;
  }
};

export default AnalyticServices;
